import React from 'react';
import { useSelector } from 'react-redux';

const userUserConnections = userConnectionsKey => {
  const { userConnections } = useSelector(state => state[userConnectionsKey]);
  const userConnectionOverrides = useSelector(state => state.userOverrides);

  const handleOverride = userConnection => {
    return userConnectionOverrides[userConnection.user.id] || userConnection;
  };

  return userConnections.map(handleOverride);
};

export default userUserConnections;
